<template>
    <div class="main">
        <img src="../assets/markets/0.webp" alt="" class="background">
        <div class="mainTitle">Based in Australia, Serving the World<br>Allvita Veterinary Products</div>
        <div class="dash"></div>
        <div class="brief">
            At Allvita, we are proud to be an Australian-based company with a global vision. Our mission is to provide high-quality, affordable, and innovative veterinary care products that improve the health and well-being of animals worldwide.
        </div>
        <div class="contentWrap">
            <div class="textWrap">
                <div class="textItemWrap">
                    <div class="dot"></div>
                    <div class="text">
                        <b>Local Expertise, Global Reach: </b>Our team of veterinary professionals, product developers, and logistics experts works closely together to ensure that Allvita’s premium products meet the needs in different regions. We thrive to learn the geographicuniqueness in animal care and husbandry, and design our products to fulfillthe individual needs.
                    </div>
                </div>
                <div class="textItemWrap">
                    <div class="dot"></div>
                    <div class="text">
                        <b>Sustainable Global Distribution: </b>We partner with distributors, retailers, and e-commerce platforms around the world to ensure that Allvita products are easily accessible, no matter where you are.
                    </div>
                </div>
                <div class="textItemWrap">
                    <div class="dot"></div>
                    <div class="text">
                        <b>Bringing the Best of Australia to the World: </b>Australia is known for its pristine environment and commitment to quality. We take pride in bringing the highest standards of Australian veterinary care to the global market, ensuring that every product is made with care, safety, and sustainability in mind.
                    </div>
                </div>
                <div class="textItemWrap">
                    <div class="dot"></div>
                    <div class="text">
                        <b>Multilingual Support and Localized Services: </b>Understanding the diversity of our global customer base, Allvita offers customer support in multiple languages and ensures that our products meet local regulations and standards, ensuring seamless service and product accessibility worldwide.
                    </div>
                </div>
            </div>
            <img class="map" src="../assets/markets/1.webp" alt="">
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import PageFooter from "./PageFooter.vue";

export default {
    components: {
        PageFooter,
    },
}
</script>

<style lang="scss" scoped>
.main {
    padding-top: $navBarHeight;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .background {
        width: 100%;
        height: auto;
    }

    .mainTitle {
        font-size: 3.5rem;
        margin-top: 4rem;
        font-family: "Montserrat", serif;
        font-weight: 700;
        text-align: center;
        color: #2C2B2B;
    }

    .dash {
        width: 25rem;
        height: 4px;
        background-color: $mainColor;
        margin-top: 1.4rem;
    }

    .brief {
        width: 70%;
        text-align: center;
        font-size: 1.3rem;
        font-family: "Montserrat", serif;
        font-weight: 400;
        margin-top: 1.9rem;
        line-height: 2.4rem;
        color: #2C2B2B;
    }

    .contentWrap {
        margin-top: 4rem;
        margin-bottom: 4rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 80%;
        align-items: flex-start;

        .textWrap {
            display: flex;
            flex-direction: column;
            width: 45%;

            .textItemWrap {
                display: flex;
                flex-direction: row;
                margin-bottom: 2.3rem;

                .dot {
                    width: 0.5rem;
                    height: 0.5rem;
                    background-color: #646465;
                    border-radius: 50%;
                    flex-shrink: 0;
                    margin-top: 0.7rem;
                }

                .text {
                    font-size: 1.1rem;
                    margin-left: 1rem;
                    font-family: "Montserrat", serif;
                    font-weight: 450;
                    color: #646465;
                    line-height: 1.8rem;
                    // letter-spacing: 0.01rem;
                }
            }

        }

        .map {
            width: 52%;
            height: auto;
            object-fit: scale-down;
        }
    }

}

@media (max-width: 768px) {
    .main {
        padding-top: 4rem;

        .mainTitle {
            font-size: 1.5rem;
            margin-top: 2rem;
            padding: 0 1.5rem;
            line-height: 1.3;
        }
        
        .dash {
            width: 80%;
            height: 3px;
        }
        
        .brief {
            width: 90%;
            font-size: 1rem;
            line-height: 1.6rem;
            margin-top: 1.5rem;
            text-align: justify;
        }
        
        .contentWrap {
            flex-direction: column;
            width: 90%;
            margin-top: 2.5rem;
            margin-bottom: 2rem;
            
            .textWrap {
                width: 100%;
                
                .textItemWrap {
                    margin-bottom: 1.5rem;
                    
                    .text {
                        font-size: 0.95rem;
                        line-height: 1.5rem;
                        margin-left: 0.8rem;
                    }
                    
                    .dot {
                        margin-top: 0.5rem;
                    }
                }
            }
            
            .map {
                width: 100%;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }
        }
    }
}
</style>